import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';

export function useDeleteRoute() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (routeId: string) => apiClient.delete(`/routes/${routeId}`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.routes.all });
    },
  });
}
